import React, { memo, useMemo } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { colors, resolveColor } from "utils/styles";

const ImageLabel = memo(function ImageLabel(props) {
	const { label, position: propPosition, backGround, color, text } = props;
	const fields = label?.fields;
	const position = propPosition || { bottom: "0px", left: "0px" };
	
	const styles = useMemo(() => ({
		background: resolveColor(backGround) || colors.red,
		color: fields?.color ? resolveColor(fields.color) : color || colors.black
	}), [backGround, fields?.color, color]);

	return (
		<>
			{text && <p>{text}</p>}
			{fields?.text &&
				documentToReactComponents(fields.text, {
					renderNode: {
						[BLOCKS.PARAGRAPH]: (_, children) => {
							return <p>{children}</p>;
						},
					},
				})}

			<style jsx>{`
				p {
					position: absolute;

					left: ${position.left || "unset"};
					bottom: ${position.bottom || "unset"};
					top: ${position.top || "unset"};
					right: ${position.right || "unset"};

					background: ${styles.background};
					margin: 0;
					font-size: 15px;
					font-family: "Open Sans";
					line-height: 28px;
					color: ${styles.color};
					letter-spacing: 0px;

					padding: 0.6em;
					text-transform: uppercase;
				}
			`}</style>
		</>
	);
});

export default ImageLabel;
